import { sectionPortalBreadcrumbs } from '@/views/sections/routeBreadcrumbs'

export const assignmentBreadcrumbs = [
  ...sectionPortalBreadcrumbs,
  {
    dynamicLabel: 'assignmentDetail',
  },
]
